<template>
  <v-app :dark="isDark">
    <div id="app" :class="{ 'dark-mode': isDark }">
      <div class="bridge-unavailable" v-if="loading">
        Loading ⌛️
      </div>
      <div class="bridge-unavailable" v-else-if="!ok">
        Your browser not supported!
      </div>
      <v-container v-else>
        <div class="calendar-header">
          <span class="current-date">{{ formattedSelectedDate }}</span>
          <v-btn icon large @click="toggleCalendar" class="calendar-toggle-btn" color="accent">
            <v-icon>{{ showCalendar ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </div>
        <v-calendar
            v-show="showCalendar"
            class="custom-calendar"
            is-expanded
            :attributes="calendarAttributes"
            :firstDayOfWeek=2
            @dayclick="selectDate"
            locale="ru"
        />
        <div class="content">
          <v-tabs
            v-model="activeTab"
            :background-color="isDark ? '#1E1E1E' : 'var(--bg-color)'"
            center-active
            dark
            class="custom-tabs"
          >
            <v-tab class="mx-auto">Активные ({{ activeTasksCount }})</v-tab>
            <v-tab class="mx-auto">Завершенные ({{ completedTasksCount }})</v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <div class="task-list" v-if="activeTasks.length > 0">
                <div v-for="task in activeTasks" :key="task.id" class="task-item" @click="openTaskDetail(task)">
                  <div class="task-content">
                    <div class="task-title">{{ task.title }}</div>
                    <div class="task-date">
                      <v-icon small class="date-icon">mdi-calendar</v-icon>
                      <span>{{ formatDate(task.date) }}</span>
                    </div>
                    <div class="task-priority" :class="task.priority.toLowerCase()">{{ task.priority }}</div>
                  </div>
                  <v-btn icon class="complete-btn" @click.stop="completeTask(task.id)">
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </div>
              </div>
              <div v-else class="no-tasks">Нет активных задач</div>
            </v-tab-item>

            <v-tab-item>
              <div class="task-list" v-if="completedTasks.length > 0">
                <div v-for="task in completedTasks" :key="task.id" class="task-item completed" @click="openTaskDetail(task)">
                  <div class="task-content">
                    <div class="task-title">{{ task.title }}</div>
                    <div class="task-date">
                      <v-icon small class="date-icon">mdi-calendar</v-icon>
                      <span>{{ formatDate(task.date) }}</span>
                    </div>
                    <div class="task-priority" :class="task.priority.toLowerCase()">{{ task.priority }}</div>
                  </div>
                </div>
              </div>
              <div v-else class="no-tasks">Нет завершенных задач</div>
            </v-tab-item>
          </v-tabs-items>
        </div>

        <!-- Router components are rendered in their own routes -->
        <!-- We only need the router-view outlet in the App.vue file -->

        <!-- Reset Button -->
<!--        <button class="reset-btn" @click="clearData">Reset</button>-->
      </v-container>
    </div>
  </v-app>
</template>

<script>
import {
  isWebViewBridgeAvailable,
  setTabActiveHandler,
  setTitle,
  backArrow,
  storage,
  headerMenuItems,
  onReady
} from '@orta/bridge';
// No need to import components as they are now part of the router

export default {

  data() {
    return {
      loading: true,
      ok: false,
      showCalendar: false, // Calendar hidden by default
      selectedDate: (() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      })(),
      activeTab: 0,
      showTaskDetail: false,
      showReportScreen: false,
      showSuccessScreen: false,
      reportText: '',
      selectedImages: [],
      selectedTask: null,
      tasks: [
        {
          id: 1,
          title: "Сделать так чтобы все работало",
          date: (() => {
            const now = new Date();
            return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
          })(),
          priority: "Высокий",
          completed: false,
          location: "809 Folger Avenue, Berkeley, CA, USA",
          description: "Уведомляем, по заявке #328 на подключение услуги Видеонаблюдение видны задержки монтажника. Выберите удобное для вас время в Пн:",
          comments: [
            {
              author: "Amanda Haydenson",
              avatar: "https://i.pravatar.cc/40?img=5",
              text: "Привет! Просто хотел узнать о статусе концепций редизайна для новой внутренней системы управления заявками.",
              time: "1 min ago"
            }
          ]
        },
        {
          id: 2,
          title: "Title",
          date: (() => {
            const now = new Date();
            return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
          })(),
          priority: "Средний",
          completed: false,
          location: "1024 Market St, San Francisco, CA, USA",
          description: "Разработать новый интерфейс для мобильного приложения по управлению задачами",
          comments: []
        },
        {
          id: 3,
          title: "Title",
          date: (() => {
            const now = new Date();
            return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
          })(),
          priority: "Норма",
          completed: false,
          description: "Провести тестирование нового модуля и составить отчет о найденных ошибках",
          comments: []
        },
        {
          id: 4,
          title: "Title",
          date: (() => {
            const now = new Date();
            return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
          })(),
          priority: "Обычный",
          completed: true,
          description: "Обновить документацию проекта в соответствии с последними изменениями",
          comments: []
        },
        {
          id: 5,
          title: "Title",
          date: (() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return `${yesterday.getFullYear()}-${String(yesterday.getMonth() + 1).padStart(2, '0')}-${String(yesterday.getDate()).padStart(2, '0')}`;
          })(),
          priority: "Обычный",
          completed: true,
          description: "Подготовить отчет о выполненных задачах за прошлую неделю",
          comments: []
        }
      ],
      theme: "light",
    };
  },
  computed: {
    // Ensure the isDark property updates when theme changes
    isDark() {
      return this.theme === 'dark';
    },
    activeTasks() {
      return this.tasks.filter(task =>
        task.date === this.selectedDate && !task.completed
      );
    },
    completedTasks() {
      return this.tasks.filter(task =>
        task.date === this.selectedDate && task.completed
      );
    },
    activeTasksCount() {
      return this.activeTasks.length;
    },
    completedTasksCount() {
      return this.completedTasks.length;
    },
    calendarAttributes() {
      const today = new Date();
      const todayLocal = today.getFullYear() + "-" +
          String(today.getMonth() + 1).padStart(2, "0") + "-" +
          String(today.getDate()).padStart(2, "0");

      const datesWithTasks = [...new Set(this.tasks.map(task => task.date))];

      return [
        ...datesWithTasks.map(date => ({
          key: date,
          highlight: {
            color: this.tasks.some(task => task.date === date && !task.completed) ? "orange" : "green",
            fillMode: "light",
          },
          dates: [date]
        })),
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "solid"
          },
          dates: [todayLocal]
        },
        {
          key: "selected",
          highlight: {
            color: "red",
            fillMode: "solid"
          },
          dates: [this.selectedDate]
        }
      ];
    },
    formattedSelectedDate() {
      const [year, month, day] = this.selectedDate.split('-').map(Number);
      return new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(year, month - 1, day));
    }
  },
  methods: {
    toggleCalendar() {
      this.showCalendar = !this.showCalendar;
    },
    async loadStoredData() {
      // Store the default dummy tasks
      const defaultTasks = [...this.tasks];
      
      // Try to load from custom storage first
      const storedTasks = await storage.getItem('tasks');
      if (storedTasks) {
        this.tasks = JSON.parse(storedTasks);
        
        // Check if there are any tasks for the current date
        const currentDate = this.selectedDate;
        const tasksForCurrentDate = this.tasks.filter(task => task.date === currentDate);
        
        // If no tasks for current date, add the dummy tasks for current date
        if (tasksForCurrentDate.length === 0) {
          console.log('No tasks found for current date, adding dummy tasks');
          
          // Update the date of default tasks to current date and add to this.tasks
          const dummyTasksForToday = defaultTasks.map(task => ({
            ...task,
            date: currentDate
          }));
          
          this.tasks = [...this.tasks, ...dummyTasksForToday];
          
          // Save the updated task list
          await storage.setItem('tasks', JSON.stringify(this.tasks));
        } else {
          console.log('Tasks found for current date:', tasksForCurrentDate.length);
        }
        
        // Also save to regular localStorage for component access
        localStorage.setItem('tasks', JSON.stringify(this.tasks));
      } else {
        // If no tasks exist yet, initialize localStorage with current tasks
        localStorage.setItem('tasks', JSON.stringify(this.tasks));
      }

      // Try to load theme from custom storage
      const storedTheme = await storage.getItem('theme');
      if (storedTheme) {
        this.theme = storedTheme;
        // Sync theme to localStorage
        localStorage.setItem('theme', this.theme);
      } else {
        // Store current theme to custom storage for sync
        await storage.setItem('theme', this.theme);
      }

      console.log('Tasks loaded and saved to localStorage:', this.tasks);
      console.log('Current theme:', this.theme);
    },
    async saveStoredData() {
      // Save to both custom storage and regular localStorage for compatibility
      await storage.setItem('tasks', JSON.stringify(this.tasks));
      // Also save to regular localStorage so the routed components can access it
      localStorage.setItem('tasks', JSON.stringify(this.tasks));

      // Save current theme to both storages
      await storage.setItem('theme', this.theme);
      localStorage.setItem('theme', this.theme);
    },
    tabActiveHandler() {
      this.$router.replace({
        name: 'HomeView'
      });
    },
    selectDate(day) {
      this.selectedDate = day.id;
      this.activeTab = 0;
    },

    completeTask(taskId) {
      const taskIndex = this.tasks.findIndex(t => t.id === taskId);
      if (taskIndex !== -1) {
        this.tasks[taskIndex].completed = true;
        this.saveStoredData();
      }
    },

    openTaskDetail(task) {
      console.log('Opening task detail for task:', task);
      // Make sure tasks are saved to localStorage before navigating
      localStorage.setItem('tasks', JSON.stringify(this.tasks));
      // Make sure the current theme is saved in localStorage
      localStorage.setItem('theme', this.theme);

      // Use router to navigate to the task detail screen with theme preserved
      this.$router.push({
        path: `/task/${task.id}`,
        query: { theme: this.theme }
      });
    },

    formatDate(dateString) {
      const [year, month, day] = dateString.split('-').map(Number);
      return new Date(year, month - 1, day).toLocaleDateString('en-US', { day: 'numeric', month: 'long' });
    },

    async clearData() {
      try {
        await storage.clear();
        localStorage.clear();
        this.tasks = [];
      } catch (error) {
        alert('Error while clearing data: ' + error);
      }
    },
    async headerMenuItemClickHandler(id) {
      if (id === 'reload') {
        await this.clearData();
        window.location.reload();
      }
    }
  },
  mounted() {
    onReady(async() => {
      this.ok = isWebViewBridgeAvailable()
      this.loading = false
      await setTitle('Мои задачи');
      await backArrow.setMode(true);
      await backArrow.setVisible(false);
      await setTabActiveHandler(this.tabActiveHandler.bind(this));

      headerMenuItems.setItems([
        {
          id: 'reload',
          icon: 'Reload',
        }
      ])
      headerMenuItems.setClickHandler(this.headerMenuItemClickHandler.bind(this))

      await this.loadStoredData();
    })
  },
  created() {
    // Get theme from route query or fallback to localStorage, with final fallback to light theme
    const themeFromQuery = this.$route.query.theme;
    const storedTheme = localStorage.getItem('theme');

    // Determine theme with priority: query param > localStorage > default
    this.theme = themeFromQuery || storedTheme || "light";

    // Store the theme in localStorage for persistence across components and navigation
    localStorage.setItem('theme', this.theme);

    console.log('HomeView created with theme:', this.theme);

  }
};
</script>


<style>
.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 8px 12px;
  background-color: var(--bg-color-secondary);
  border-radius: 8px;
}

.calendar-toggle-btn {
  background-color: var(--bg-color-secondary);
}

.current-date {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color);
}
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: var(--bg-color);
}

:root {
  --bg-color: #ffffff;
  --bg-color-secondary: #F0F3F6;
  --text-color: #000000;
}

.dark-mode {
  --bg-color: #121212;
  --bg-color-secondary: #1B1B1B;
  --text-color: #ffffff;
}

.bridge-unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  height: 100vh; /* Full screen height */
}

.custom-calendar {
  background: var(--bg-color) !important;
  color: var(--text-color) !important;
}

.body-common {
  border-radius: 16px;
  padding: 12px 2px 4px;
  display: flex;
  flex-direction: column;
}

.body-header {
  color: #FFFFFF;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.content {
  flex: 1;
}

.body-inactive {
  background: linear-gradient(#113997, #ADC4FC);
}

.body-active {
  background: linear-gradient(#1EBC3B, #B0D8BF);
}

.days-container {
  display: flex;
  justify-content: space-between;
  margin: 12px 2px 2px;
  background: var(--bg-color);
  border-radius: 16px;
  padding: 12px;
  gap: 30px;
}

.time-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  padding: 7px 9px;
  background: var(--bg-color-secondary);
  border-radius: 12px;
}

.time-container-header {
    font-size: 10px;
}

.time-container-time {
  font-size: 18px;
  text-align: center;
}

.time-container-time-text {
  color: var(--text-color);
}

.time-inactive {
  opacity: 0.65;
}

.button-container {
  display: flex;
  margin-top: auto;
}

.button {
  flex: 1;
  background: #113997;
  margin: 0;
  border-radius: 12px;
  color: white;
  padding: 16px;
  font-weight: 600;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
}

.button-active {
  background: var(--bg-color);
  color: #FF5757;
  border-style: solid;
  border-color: #FF5757;
}

.cancel-button {
  background: var(--bg-color-secondary);
  color: var(--text-color);
}

p {
  margin: 0 !important;
}

.bottom-sheet-container {
  padding-top: 56px;
  overflow: visible !important;
}

.buttons-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  padding: 12px 24px;
}

.bottom-sheet-icon {
  display: flex;
  justify-content: center;
  align-self: center;
}

.bottom-sheet-title {
  text-align: center;
  word-break: keep-all;
  font-weight: 600;
  font-size: 20px;
  padding: 24px;
  line-height: 120%;
  font-family: 'Inter', sans-serif;
  color: var(--text-color);
}

.reset-btn {
  top: 0;
  left: 0;
}

.v-sheet.v-card {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background: var(--bg-color-secondary) !important;
}

.vc-title {
  color: var(--text-color) !important;
}

.custom-tabs .v-tab:not(.v-tab--active) {
  color: #9E9E9E !important;
}

.custom-tabs .v-tab--active {
  color: var(--text-color) !important;
}
.task-list {
  padding: 16px;
  background: var(--bg-color);
}

.task-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  margin-bottom: 8px;
  background: var(--bg-color-secondary);
  border-radius: 8px;
}

.task-item.completed {
  opacity: 0.7;
}

.task-content {
  flex: 1;
  margin-right: 12px;
}

.task-title {
  font-size: 16px;
  color: var(--text-color);
  margin-bottom: 4px;
}

.task-priority {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.task-priority.высокий {
  background: #FFE5E5;
  color: #FF5757;
}

.task-priority.средний {
  background: #FFF4E5;
  color: #FF9F57;
}

.task-priority.норма {
  background: #E5FFE9;
  color: #57FF7C;
}

.task-priority.обычный {
  background: #E5F4FF;
  color: #579FFF;
}

.no-tasks {
  text-align: center;
  padding: 24px;
  color: #9E9E9E;
  font-size: 14px;
}

.task-date {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  color: #757575;
  font-size: 12px;
}

.date-icon {
  margin-right: 4px;
  font-size: 14px;
}






</style>
